import { insertItemIntoArrayAtPosition } from '~services/immutable';
import { TableDataItemShape, TableDataItemType, TableDataShape } from './Table';

export const createDefaultGrant = (name = '', id: number, type: TableDataItemType): TableDataItemShape => ({
  name,
  id,
  view: false,
  update: false,
  create: false,
  delete: false,
  publish: false,
  set_grants: false,
  view_draft: false,
  type,
});

export const generateGroupGrants = (groups: GrantGroup[], grants: RoleGrantDto[]): TableDataShape =>
  (groups || []).map(group => {
    const grantGroup = (grants || []).find(grantGroup => grantGroup.id === group.id);
    return {
      ...createDefaultGrant(group.name, group.id, 'group'),
      ...(grantGroup || {}),
    };
  });

export const generateUserGrants = (grants: RoleGrantDto[]): TableDataShape =>
  (grants || []).map(grant => ({
    ...createDefaultGrant(grant.username, grant.id, 'user'),
    ...grant,
  }));

export const generateTableData = (menuLinkGrants: MenuLinkGrantsDto): TableDataShape => [
  ...generateGroupGrants(menuLinkGrants?.groups || [], menuLinkGrants.grants.groups),
  ...generateUserGrants(menuLinkGrants.grants.users),
];

export const generateInheritedTableData = (menuLinkGrants: MenuLinkGrantsDto): TableDataShape => [
  ...generateGroupGrants(menuLinkGrants?.groups || [], menuLinkGrants.inherit_grants.groups),
  ...generateUserGrants(menuLinkGrants.inherit_grants.users),
];

export const generateUpdateData = (
  grantGroups: GrantGroup[],
  tableData: TableDataShape,
  scope: MenuLinkGrantScope,
): UpdateMenuLinkGrantsDto => {
  const groupIds = grantGroups.map(g => g.id);
  const isGroup = (groupId: number) => groupIds.includes(groupId);

  const groups: UpdateMenuLinkGrantsDto['groups'] = [];
  const users: UpdateMenuLinkGrantsDto['users'] = [];

  tableData.forEach(row => {
    if (isGroup(row.id)) {
      groups.push(row);
    } else {
      users.push(row);
    }
  });

  return {
    scope,
    groups,
    users,
  };
};

export const addUserToData = (tableData: TableDataShape, name: string, id: number): TableDataShape => {
  const isUserAlreadyInData = !!tableData.find(item => item.id === id);
  return isUserAlreadyInData
    ? tableData
    : insertItemIntoArrayAtPosition<TableDataItemShape>(tableData, createDefaultGrant(name, id, 'user'));
};

export const getGrantsScope = (menuLinkGrants: MenuLinkGrantsDto): MenuLinkGrantScope =>
  menuLinkGrants?.scope || 'inherit';

export const isValidScope = (scopeToCheck: string): scopeToCheck is MenuLinkGrantScope =>
  scopeToCheck === 'inherit' || scopeToCheck === 'subtree' || scopeToCheck === 'node';
